<template>
  <b-button
    @click="$emit('click')"
    :variant="active ? 'primary' : 'dark'"
    size="sm"
    block
    :class="['py-2', 'px-2', 'h-100', 'text-left']"
  >
    <i :class="['far', 'fa-' + (icon ? icon : 'cube'), 'font-2xl']"></i>

    <span
      class="pl-3 text-uppercase d-inline-block position-relative"
      style="top: -5px;"
      >{{ label }}</span
    >
  </b-button>
</template>

<script>
export default {
  name: "SelectButton",

  props: {
    icon: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    active: {
      type: Boolean,
      default: false
    }
  }
};
</script>
